export const STUDENT_INQUIRIES = '/student-inquiries' as const
export const PROOF_OF_STUDY_LIST = '/proof-of-study/list' as const
export const PROOF_OF_STUDY = '/proof-of-study' as const
